import React, { memo } from 'react';
import { useHistory, useLocation } from 'react-router';

// Components
import MeetingItemDetailModal from 'Shared/components/MeetingItemDetailPanel/MeetingItemDetailModal';

import './CommentsAreaWrapper.scss';

type Props = {
  previousLocation?: {
    pathname: string;
    state?: { modal: boolean };
  };
};

const CommentsAreaWrapper = ({ previousLocation }: Props) => {
  const { pathname } = useLocation();
  const history = useHistory();

  // TODO (josh): test matchPath to see if it will work here
  const isOpen = pathname.includes('/item/') && pathname.includes('/comments');

  if (!isOpen) return null;

  const handleCloseClick = () => {
    if (previousLocation.pathname === location.pathname) {
      const backUrl = location.pathname.split('/item/')[0];
      const backPathname = backUrl === '' ? '/' : backUrl;
      history.push({
        pathname: backPathname,
        state: { modal: previousLocation.state?.modal, preventPreviousRouteChange: previousLocation.state?.modal },
      });
    } else {
      history.goBack();
    }
  };

  return <MeetingItemDetailModal onClose={handleCloseClick} />;
};

export default memo(CommentsAreaWrapper);
